import { render, staticRenderFns } from "./HelpSelfPublishing.vue?vue&type=template&id=5d4ba55e&scoped=true&"
import script from "./HelpSelfPublishing.vue?vue&type=script&lang=js&"
export * from "./HelpSelfPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ba55e",
  null
  
)

export default component.exports